import * as yup from "yup";
import { startOfMonth } from "date-fns";
import { MonthsNumberMap } from "./../../enums/calendar";

export const addCreditCardSchema = yup.object().shape({
  streetAddress: yup
    .string()
    .required("Address is Required")
    .test(
      "35Characters",
      "Please enter a maximum of 35 characters.",
      (val = "") => val.length < 36
    ),
  streetAddress2: yup.string(),
  cardholder: yup.string().required("Card Holder name is required"),
  cardNumber: yup.number().required("Card Number is required"),
  expDate: yup.string().required("Expiry date required"),
  cvv: yup
    .string()
    .required("CVV is required")
    .test("3Digits", "Cvv must have 3 digits", (val) => {
      if (!val) {
        return false;
      }
      if (val.toString().length == 3) {
        return true;
      }
      return false;
    }),
  state: yup.string().required("State is required"),
  city: yup.string().required("City is required"),
  zip: yup.string().matches(/^\d+$/, "Zip must only contain numbers").required("Zip is required"),
});

export const verifyBillingAddressSchema = yup.object().shape({
  streetAddress: yup
    .string()
    .required("Address is Required")
    .test(
      "35Characters",
      "Please enter a maximum of 35 characters.",
      (val = "") => val.length < 36
    ),
  streetAddress2: yup.string(),
  state: yup.string().required("State is required"),
  city: yup.string().required("City is required"),
  zip: yup.string().matches(/^\d+$/, "Zip must only contain numbers").required("Zip is required"),
});

export const addBankAccountSchema = yup.object().shape({
  accountHolder: yup.string().required("Account Holder is required"),
  accountType: yup.string().required("Account Type is required"),
  routingNumber: yup
    .string()
    .required("Routing number is required")
    .matches(/^\d+$/, "Routing number must only contain numbers")
    .test("9Digits", "Please enter 9 digits.", (val = "") => val?.length === 9),
  accountNumber: yup
    .string()
    .matches(/^\d+$/, "Account Number must only contain numbers")
    .min(5, "Account Number must have at least 5 digits")
    .max(20, "Account Number must have a maximum of 20 digits")
    .required("Account Number is required"),
  confirmAccountNumber: yup
    .string()
    .matches(/^\d+$/, "Account Number must only contain numbers")
    .test(
      "confirmAccountNumber",
      "Account Numbers do not match. Please re-enter.",
      // Relies on this don't use arrow function
      function (value: any) {
        const yupRef = yup.ref("accountNumber");
        return value === this.resolve(yupRef);
      }
    ),
});
